<template>
  <div>
    <el-autocomplete
      v-model="specialSearch.parent"
      :fetch-suggestions="parentAsync"
      placeholder="项目类别"
      @select="handleSelect"
      value-key="name"
      class="parent m-r-20"
    ></el-autocomplete>
    <el-autocomplete
      v-model="specialSearch.child"
      :fetch-suggestions="childAsync"
      placeholder="项目"
      value-key="name"
      @select="handleSelectChild"
      :disabled="!this.specialSearchItem.parent.name"
      class="child"
    ></el-autocomplete>
  </div>
</template>

<script>
import { Autocomplete } from 'element-ui';
import { base } from '@/api';

export default {
  components: { ElAutocomplete: Autocomplete },
  props: {
    id: {
      required: true
    },
    childMethod: {
      type: Function
    }
  },
  data() {
    return {
      specialSearch: {
        parent: '',
        child: ''
      },
      specialSearchItem: {
        parent: {},
        child: {}
      }
    };
  },
  methods: {
    reset() {
      this.specialSearch = {
        parent: '',
        child: ''
      };
      this.specialSearchItem = {
        parent: {},
        child: {}
      };
    },
    handleSelect(item) {
      this.specialSearchItem.parent = { ...item };
      this.childAsync();
    },
    handleSelectChild(item) {
      this.$emit('result-data', [item]);
    },
    async parentAsync(query, cb) {
      const res = await base.specialRoot({
        query
      });
      if (res && res.data) {
        cb(res.data.list);
      }
    },
    async getChild(query) {
      const method = this.childMethod || base.getSpecialByOrg;
      if (this.specialSearchItem.parent.id) {
        const res = await method({
          query,
          parent_id: this.specialSearchItem.parent.id,
          org_id: this.id,
          id: this.id
        });
        return res;
      }
      this.$$message.warning('请先选择部门');
      return null;
    },
    async childAsync(query, cb) {
      const res = await this.getChild(query);
      if (res && res.data) {
        this.$emit('result-data', res.data.list);
        if (cb) cb(res.data.list);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.parent,
.child {
  width: 200px;
}
</style>
